import { gql } from 'graphql-tag'

export const chooseTeacherClass = gql`
  mutation ChooseTeacherClass($classId: Int!) {
    chooseTeacherClass(classId: $classId)
  }
`

export const removeTeacherClass = gql`
  mutation RemoveTeacherClass($classId: Int!) {
    removeTeacherClass(classId: $classId)
  }
`
